import type { AccountLinkKind, AccountStatus } from "@yjsgames/account-link";

/** 연동 버튼 라벨 i18n 키 — 플랫폼별. */
export const CONNECT_LABEL_KEY: Record<AccountLinkKind, string> = {
  playGames: "settings.linkAccount.connectPlayGames",
  gameCenter: "settings.linkAccount.connectGameCenter",
};

/**
 * 계정 연동 모달의 뷰 상태(Humble View) — 순수. 연동 여부에 따라 상태 라벨 키 + 연동버튼/안내 토글을
 * 결정한다. AccountLinkModal.applyStatus가 이 결과로 Phaser 객체를 갱신한다(렌더 의존 0 → 단위테스트).
 */
export interface AccountLinkView {
  /** 상태 라벨 i18n 키 — 연동됨/연동되지 않음. */
  readonly statusKey: "settings.linkAccount.linked" | "settings.linkAccount.unlinked";
  /** linked 라벨 보간용 이름(displayName ?? email ?? ""). unlinked면 빈 문자열. */
  readonly statusName: string;
  /** 연동 버튼 노출(미연동) vs "이미 연동되었습니다" 안내(연동됨). */
  readonly showConnect: boolean;
  /** 연동 버튼 라벨 i18n 키(플랫폼별) — showConnect일 때 사용. */
  readonly connectLabelKey: string;
}

export function resolveAccountLinkView(status: AccountStatus, kind: AccountLinkKind): AccountLinkView {
  const connectLabelKey = CONNECT_LABEL_KEY[kind];
  if (status.linked) {
    return {
      statusKey: "settings.linkAccount.linked",
      statusName: status.displayName ?? status.email ?? "",
      showConnect: false,
      connectLabelKey,
    };
  }
  return {
    statusKey: "settings.linkAccount.unlinked",
    statusName: "",
    showConnect: true,
    connectLabelKey,
  };
}
